import { DollarSign, FileText, Target } from 'lucide-react'
import { Input, Textarea } from '@/components/ui/Input'
import type { DealFormData } from '@/components/RocketSearch/rocketDealsFormTypes'

interface RocketDealsFormDealFieldsProps {
  form: DealFormData
  dealNome: string
  getError: (field: string) => string | undefined
  setField: <K extends keyof DealFormData>(key: K, value: DealFormData[K]) => void
}

export function RocketDealsFormDealFields({
  form,
  dealNome,
  getError,
  setField,
}: RocketDealsFormDealFieldsProps) {
  return (
    <div className='space-y-4'>
      <h4 className='text-xs font-semibold text-[var(--font-color-h3)] uppercase tracking-wider'>
        Informações do Deal
      </h4>

      <Input
        label='Nome do Deal'
        placeholder='Empresa - Rocket Search'
        value={dealNome || form.dealNome}
        onChange={(e) => setField('dealNome', e.target.value)}
        error={getError('dealNome')}
        hint='Preenchido automaticamente com base na empresa'
        icon={<FileText size={13} />}
      />

      <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
        <Input
          label='Valor (R$)'
          type='number'
          placeholder='0,00'
          value={form.valor || ''}
          onChange={(e) => setField('valor', Number(e.target.value))}
          error={getError('valor')}
          icon={<DollarSign size={13} />}
        />

        <div className='flex flex-col gap-1.5'>
          <label className='font-medium text-[var(--font-color-label)] uppercase tracking-wider text-[11px]'>
            Probabilidade: {form.probabilidade}%
          </label>
          <div className='flex items-center gap-3'>
            <input
              type='range'
              min={0}
              max={100}
              value={form.probabilidade}
              onChange={(e) => setField('probabilidade', Number(e.target.value))}
              className='flex-1 h-1.5 rounded-full appearance-none cursor-pointer'
              style={{
                background: `linear-gradient(to right, var(--brand-primary) ${form.probabilidade}%, rgba(255,255,255,0.1) ${form.probabilidade}%)`,
              }}
            />
            <Target
              size={14}
              className='text-[var(--brand-primary)] shrink-0'
            />
          </div>
          <div className='flex justify-between text-[10px] text-[var(--font-color-muted)]'>
            <span>0%</span>
            <span>25%</span>
            <span>50%</span>
            <span>75%</span>
            <span>100%</span>
          </div>
        </div>
      </div>

      <Textarea
        label='Observações'
        placeholder='Informações adicionais sobre o deal...'
        value={form.observacoes}
        onChange={(e) => setField('observacoes', e.target.value)}
        rows={3}
      />
    </div>
  )
}
